
import { emergencyAlertSources } from '../../../mocks/emergency';

export default function AlertSourcesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-teal-600 bg-teal-50 text-sm font-medium px-4 py-1.5 rounded-full mb-4">
            <i className="ri-notification-3-line"></i>
            Stay Informed
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Emergency Alert Systems</h2>
          <p className="text-gray-600 text-sm max-w-xl mx-auto">Sign up for these official notification services to receive real-time emergency alerts</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {emergencyAlertSources.map((source) => (
            <a
              key={source.name}
              href={source.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-white rounded-xl border border-gray-200 p-6 hover:shadow-lg hover:border-teal-200 transition-all group cursor-pointer"
            >
              <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-100 transition-colors">
                <i className={`${source.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-2">{source.name}</h3>
              <p className="text-gray-500 text-xs leading-relaxed mb-4">{source.description}</p>
              <span className="inline-flex items-center gap-1 text-teal-600 text-xs font-medium group-hover:gap-2 transition-all">
                Sign Up <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>

        {/* Preparedness CTA */}
        <div className="mt-16 relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/4c5ea24ef7556fe93a7ee63dd96bd773.jpg"
              alt="Emergency preparedness kit"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/75 to-gray-900/50"></div>
          </div>
          <div className="relative z-10 py-14 px-8 md:px-14 max-w-2xl">
            <h3 className="text-2xl font-bold text-white mb-3">Build Your Emergency Kit</h3>
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Every Roseville household should have a 72-hour emergency kit ready. The basics include water, non-perishable food, flashlight, batteries, first aid supplies, medications, important documents, and cash.
            </p>
            <a
              href="https://www.ready.gov/kit"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              View Full Checklist at Ready.gov
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
